module.exports = __webpack_public_path__ + "ce2204a227a3bdc0e2e1b9943f51ef4d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/support-widget.svg
// module id = U6t4
// module chunks = 0